import {
  Address,
  Airport,
  ConnectingAirport,
  LuggageRequirements,
  OversizeLuggageRequirements,
  PassengerRequirements,
  Transfer,
  TransferDirection,
} from './types'

export enum PageURLs {
  // TODO: Can the URLs be changed? Make consistency / grouping easier.
  Home = '/',
  BookNow = '/book-now/',
  AddTransfer = '/book-now/add-transfer/',
  CompleteBooking = '/book-now/complete-booking/',
  BookingReview = '/book-now/booking-review/',
  Billing = '/billing/',
  Transfers = '/my-transfers/',
  Login = '/login/',
  Register = '/register/',
  PasswordEmail = '/password/email/',
  PasswordReset = '/password/reset/',
  ProfileSettings = '/profile-settings/',
  OrderConfirmation = '/orders/:order/actions/confirm',
}

// TODO: Deprecate, both airport + address to have `formatted_title`
export enum Location {
  Airport = 'Airport',
  PostalAddress = 'PostalAddress',
}

export const Config = {
  GroupHeaderDateFormat: 'LLL yyyy',
  OrderSummaryDateFormat: 'd LLL',
  DateFormat: 'eee d LLL',
  TimeFormat: 'HH:mm',
}

export const formatCurrency = (value: number): string => (value / 100).toFixed(2)

export const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max)

export const pluckPassengerRequirements = (x: PassengerRequirements): PassengerRequirements => {
  const { adults, children, infants } = x

  return { adults, children, infants }
}

export const pluckLuggageRequirements = (x: LuggageRequirements): LuggageRequirements => {
  const { luggage_small, luggage_large } = x

  return { luggage_small, luggage_large }
}

export const pluckOversizedLuggageRequirements = (x: OversizeLuggageRequirements): OversizeLuggageRequirements => {
  const { oversized_child_seats, oversized_prams, oversized_skis, oversized_snowboards, oversized_golf_clubs } = x

  return {
    oversized_child_seats,
    oversized_prams,
    oversized_skis,
    oversized_snowboards,
    oversized_golf_clubs,
  }
}

export const pluckAddress = (x: Address): Address => {
  const {
    address_place_id,
    address_name,
    address_formatted,
    address_components,
    address_country,
    address_lat,
    address_lng,
  } = x

  return {
    address_place_id,
    address_name,
    address_formatted,
    address_components,
    address_country,
    address_lat,
    address_lng,
  }
}

export const pluckAirport = (x: Airport): Airport => {
  const { airport_name, airport_code, airport_country, airport_lat, airport_lng } = x

  return { airport_name, airport_code, airport_country, airport_lat, airport_lng }
}

export const pluckConnectingAirport = (x: ConnectingAirport): ConnectingAirport => {
  const {
    connecting_airport_name,
    connecting_airport_code,
    connecting_airport_country,
    connecting_airport_lat,
    connecting_airport_lng,
  } = x

  return {
    connecting_airport_name,
    connecting_airport_code,
    connecting_airport_country,
    connecting_airport_lat,
    connecting_airport_lng,
  }
}

export const pluckReverseDirection = (direction: TransferDirection) => {
  return direction === TransferDirection.ToAirport ? TransferDirection.ToAddress : TransferDirection.ToAirport
}

export const swapAirportAndConnectingAirport = (transfer: Transfer): Airport & ConnectingAirport => {
  return {
    airport_name: transfer.connecting_airport_name,
    airport_code: transfer.connecting_airport_code,
    airport_country: transfer.connecting_airport_country,
    airport_lat: transfer.connecting_airport_lat,
    airport_lng: transfer.connecting_airport_lng,

    connecting_airport_name: transfer.airport_name,
    connecting_airport_code: transfer.airport_code,
    connecting_airport_country: transfer.airport_country,
    connecting_airport_lat: transfer.airport_lat,
    connecting_airport_lng: transfer.airport_lng,
  }
}
